import { render, staticRenderFns } from "./transactionBtn.vue?vue&type=template&id=3b2ca359"
import script from "./transactionBtn.vue?vue&type=script&lang=js"
export * from "./transactionBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports